import ComplianceSection from "../components/ComplianceSection/ComplianceSection";
import ContentContainer from "../components/ContentContainer";
import MainLayout from "../components/MainLayout";
import Separator from "../components/Separator";
import Typography from "../components/Typography";
import DownloadActivityReportCard from "../components/DownloadActivityReportCard/DownloadActivityReportCard";

const ReportsPage = () => {
    return (
        <MainLayout>
            <div className="py-8 px-5 flex flex-col gap-6 md:gap-0 md:flex-row md:items-center md:justify-between">
                <Typography
                    variant="display-small"
                    component="h1"
                    className="text-deep-ocean-20"
                >
                    Reports
                </Typography>
            </div>
            <Separator />
            <ContentContainer className="space-y-8 py-8">
                <ComplianceSection />
                <Typography
                    variant="headline-small"
                    component="h2"
                    className="pt-4"
                >
                    Download Report
                </Typography>
                <DownloadActivityReportCard />
            </ContentContainer>
        </MainLayout>
    );
};

export default ReportsPage;
